import * as Yup from 'yup'

export const userSchema = Yup.object().shape({
  birthDate: Yup.string().required('Digite uma data de nascimento'),
  email: Yup.string().email('Digite um email válido').required('Digite um email'),
  familyName: Yup.string()
    .matches(/^[a-záàâãéèêíïóôõöúçñ ]+$/i, 'Digite um sobrenome válido')
    .required('Digite um sobrenome'),
  gender: Yup.string().required('Selecione um gênero'),
  givenName: Yup.string()
    .matches(/^[a-záàâãéèêíïóôõöúçñ ]+$/i, 'Digite um nome válido')
    .min(2, 'Digite um nome válido')
    .required('Digite um nome'),
  postalCode: Yup.string().length(8, 'CEP Inválido'),
  whatsapp: Yup.string()
    .matches(/^\+55.*$/gm, 'O número precisa começar com +55')
    .min(11, 'Digite um número válido')
    .max(19, 'Limite máximo de caracteres são 19')
    .required('Digite um número de whatsapp')
})
